export default __webpack_public_path__ + "static/media/YPV2-22-TrainerHandbook-AddendaCombined-Mod1-2-3.29c11d3d.pdf";